import React from 'react';

const Error = () => {
  return (
    <h3
      style={{
        textAlign: 'center',
        color: 'red',
      }}
    >
      404 This page is not found
    </h3>
  );
};

export default Error;
